import { render } from "./PaginationArrowLeftDisabled.vue?vue&type=template&id=5992b598"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PaginationArrowLeftDisabled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5992b598"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5992b598', __exports__)) {
    api.reload('5992b598', __exports__)
  }
  
  module.hot.accept("./PaginationArrowLeftDisabled.vue?vue&type=template&id=5992b598", () => {
    api.rerender('5992b598', render)
  })

}


export default __exports__